import { EventModel } from '@modules/event/event-model';

const { fields } = EventModel;

export default [
  fields.id,
  fields.title,
  fields.description,
  fields.date,
  fields.hour,
  fields.duration,
  fields.location,
  fields.createdAt
];
